<template>
  <div class="w-flex-div">
    <div style="padding: 0 10px">
      <piczoom :src="getSrc">
        <img style="width: 100%; min-height: 340px" :src="getSrc" />
      </piczoom>
    </div>
    <div style="padding: 0 10px">
      <div class="font-bold" style="padding: 6px 0; background: #f4f4f4">
        {{ data.plateNumber }}
      </div>
      <div style="padding: 6px 0; background: #f4f4f4; margin-top: 6px">
        {{ data.passTime }}
      </div>
      <div v-if="data.carList && data.carList.length > 0" style="color: #999">
        <div class="w-flex-div" style="padding-top: 20px">
          <div
            v-for="(item, index) in data.carList"
            :key="'c' + index"
            class="text-left p-x-10"
          >
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span style="font-weight: 600" v-if="index == 1">电子采集设备</span>
                <span style="font-weight: 600" v-if="index == 2">相机采集设备</span>
              </div>
              <div>
                车辆类型：<span>{{ item.plateTypeName }}</span>
              </div>
              <div>
                车身颜色：<span>{{ item.carColorName }}</span>
              </div>
              <div>
                车辆品牌：<span>{{ item.plateColorName }}</span>
              </div>
            </el-card>
          </div>
        </div>
      </div>
      <div class="w-flex-div" style="padding-top: 20px">
        <div>
          <el-button
            @click="$util.downloadImage(getSrc, `车辆库-${new Date().getTime()}`)"
            type="success"
            style="width: 80%"
            >图片下载</el-button
          >
        </div>
        <div>
          <el-button type="success" style="width: 80%">查看轨迹</el-button>
        </div>
      </div>
      <div class="w-flex-div" style="padding-top: 14px">
        <div>
          <el-button type="success" style="width: 80%">以图搜车</el-button>
        </div>
        <div></div>
      </div>
    </div>
  </div>
</template>

<script>
import piczoom from "@/components/piczoom.vue";
export default {
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    piczoom,
  },
  getSrc() {
    return this.data.storageUrl1 || this.data.imgsrc || "static/image/test.png";
  },
};
</script>

<style lang="scss">
.w-flex-div {
  display: flex;
  .el-card__header {
    padding: 8px;
  }
  .el-card__body {
    padding: 8px;
    line-height: 26px;
  }
  .p-x-10 {
    padding: 0 10px;
  }
  > div {
    flex: 1;
  }
  .text-left {
    text-align: left;
  }
}

.font-bold {
  font-weight: bold;
  padding: 6px 0;
  font-size: 16px;
  color: #403f3f;
}
</style>



// WEBPACK FOOTER //
// src/components/cards-info/carInfoCxbf.vue